const scopeUtils = {
    apply: function ($scope, fn) {
        if (!$scope || !$scope.$root)
            return;

        let phase = $scope.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            if (fn && (typeof (fn) === 'function')) {
                fn();
            }
        } else {
            $scope.$apply(fn);
        }
    }
};

export default scopeUtils;



// WEBPACK FOOTER //
// ./src/utils/scope.js